"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.makeConfig = exports.machineJSON = exports.createOSWApptInfoMachine = void 0;
var _xstate = require("xstate");
var _loadScript = _interopRequireDefault(require("load-script"));
var _epicOSWUtils = require("../../lib/epicOSWUtils");
var _States = require("../../lib/constants/States");
const actions = {
  setExternalIDAndVisitType: (0, _xstate.assign)({
    externalID: (ctx, ev) => ev.data.externalID,
    visitType: (ctx, ev) => ev.data.visitType
  }),
  loadExternalJS: ctx => {
    (0, _loadScript.default)(ctx.epicOSWConfig.open_scheduling_js_url, {
      async: false
    });
  }
};
const guards = {
  cannotCompleteExternalBooking: (ctx, ev) => {
    const {
      externalID,
      visitType
    } = ev.data;
    return !externalID || !visitType;
  }
};
const services = {
  getExternalIDAndVisitType: async ctx => {
    const {
      provider,
      epicOSWConfig
    } = ctx;
    return {
      externalID: (0, _epicOSWUtils.getExternalIDForProvider)(provider),
      visitType: (0, _epicOSWUtils.getExtVisitTypeForProvider)(provider, epicOSWConfig)
    };
  }
};

// This is exposed for snapshot testing
const machineJSON = _ref => {
  let {
    provider,
    epicOSWConfig
  } = _ref;
  return {
    id: `Machine__${_States.oswApptInfo}`,
    initial: _States.initializing,
    context: {
      provider,
      epicOSWConfig
    },
    states: {
      [_States.initializing]: {
        invoke: {
          id: 'getExternalIDAndVisitType',
          src: 'getExternalIDAndVisitType',
          onDone: [{
            cond: 'cannotCompleteExternalBooking',
            target: _States.error
          }, {
            actions: ['setExternalIDAndVisitType', 'loadExternalJS'],
            target: _States.success
          }],
          onError: _States.error
        }
      },
      [_States.success]: {},
      [_States.error]: {}
    }
  };
};
exports.machineJSON = machineJSON;
const createOSWApptInfoMachine = _ref2 => {
  let {
    config = makeConfig(),
    ...props
  } = _ref2;
  return (0, _xstate.Machine)(machineJSON(props)).withConfig(config);
};
exports.createOSWApptInfoMachine = createOSWApptInfoMachine;
const makeConfig = () => ({
  actions,
  guards,
  services
});
exports.makeConfig = makeConfig;